export default __webpack_public_path__ + "static/media/btn-dl-baazaar.37e84797.png";